export async function geoFindMe() {
  if (!("geolocation" in navigator)) {
    console.warn("Geolocation is not supported by your browser.");
    return null;
  }

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    return position;
    //const { latitude, longitude } = position.coords;
    //return { 
    //    latitude:latitude, 
    //    longitude:longitude };
  } catch (err) {
    console.error("Error getting location:", err.message);
    return null;
  }
}

